"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DrawingToolsApi_drawingToolsManager, _DrawingToolsApi_restrictions;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingToolsApi = void 0;
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const DrawingToolsManager_1 = require("../../business/implementation/DrawingToolsManager");
class DrawingToolsApi {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(viewport, callbacks, settings, defaultTextures, parentNode) {
        // #region Properties (2)
        _DrawingToolsApi_drawingToolsManager.set(this, void 0);
        _DrawingToolsApi_restrictions.set(this, {});
        __classPrivateFieldSet(this, _DrawingToolsApi_drawingToolsManager, new DrawingToolsManager_1.DrawingToolsManager(viewport, callbacks, settings, defaultTextures, parentNode), "f");
        for (const token in __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions) {
            if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
                viewer_rendering_engine_intersection_restriction_engine_1.PlaneRestriction)
                __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.PlaneRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
            if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
                viewer_rendering_engine_intersection_restriction_engine_1.GeometryRestriction)
                __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.GeometryRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
            if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
                viewer_rendering_engine_intersection_restriction_engine_1.PointRestriction)
                __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.PointRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
            if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
                viewer_rendering_engine_intersection_restriction_engine_1.LineRestriction)
                __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.LineRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
            if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
                viewer_rendering_engine_intersection_restriction_engine_1.CameraPlaneRestriction)
                __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.CameraPlaneRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
        }
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (7)
    get closed() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").closed;
    }
    get paused() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").paused;
    }
    get pointsData() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").getPointsData();
    }
    get uuid() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").uuid;
    }
    get restrictions() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f");
    }
    get showDistanceLabels() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").showDistanceLabels;
    }
    set showDistanceLabels(value) {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").showDistanceLabels = value;
    }
    get showPointLabels() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").showPointLabels;
    }
    set showPointLabels(value) {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").showPointLabels = value;
    }
    // #endregion Public Getters And Setters (7)
    // #region Public Methods (11)
    addPoint(index, position) {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").addPoint(index, position);
    }
    addRestriction(properties, incomingToken) {
        const token = __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").addRestriction(properties, incomingToken);
        if (!token)
            return;
        if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
            viewer_rendering_engine_intersection_restriction_engine_1.PlaneRestriction)
            __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.PlaneRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
        if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
            viewer_rendering_engine_intersection_restriction_engine_1.GeometryRestriction)
            __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.GeometryRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
        if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
            viewer_rendering_engine_intersection_restriction_engine_1.PointRestriction)
            __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.PointRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
        if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
            viewer_rendering_engine_intersection_restriction_engine_1.LineRestriction)
            __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.LineRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
        if (__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token] instanceof
            viewer_rendering_engine_intersection_restriction_engine_1.CameraPlaneRestriction)
            __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token] = new viewer_rendering_engine_intersection_restriction_engine_1.CameraPlaneRestrictionApi(__classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").restrictions[token]);
        return __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token];
    }
    canRedo() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").canRedo();
    }
    canUndo() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").canUndo();
    }
    pause() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").pause();
    }
    continue() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").continue();
    }
    cancel() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").cancel();
    }
    cancelDrag() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").cancelDrag();
    }
    isInteractionActive() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").isInteractionActive();
    }
    close() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").close();
    }
    movePoint(index, position, temporary, skipConstraints) {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").movePoint(index, position, undefined, temporary, skipConstraints);
    }
    redo() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").redo();
    }
    removePoint(index) {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").removePoint(index);
    }
    removeRestriction(token) {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").removeRestriction(token);
        delete __classPrivateFieldGet(this, _DrawingToolsApi_restrictions, "f")[token];
    }
    undo() {
        __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").undo();
    }
    update() {
        return __classPrivateFieldGet(this, _DrawingToolsApi_drawingToolsManager, "f").update();
    }
}
exports.DrawingToolsApi = DrawingToolsApi;
_DrawingToolsApi_drawingToolsManager = new WeakMap(), _DrawingToolsApi_restrictions = new WeakMap();
//# sourceMappingURL=DrawingToolsApi.js.map